import { legacyLoansDataGetters } from '@/store/modules/legacyLoansData/routines'

export default {
  [legacyLoansDataGetters.LEGACY_LOANS_DATA]: state => {
    return state.legacyLoansData
  }
}
